<template>
	<div class="main-div-20220-14" ref="main-div" :style="'max-width:' + 1600 + 'px'">
		<!--头部-->
		<div class="top-div">
			<div class="top-text-div">
				<div class="input-box-div">
					<!-- 搜索栏 -->
					<div class="search-bar-div">
						<div class="country-select-div">
							<div class="group">
								<el-dropdown trigger="click" placement="bottom" @command="(v) => submitSearch.country=v">
									<span style="font-size: 14px;color: #909399;cursor: pointer;">
										<i :class="'fi fi-' + getCountryObjByCity(submitSearch.country).icon"> </i>
										<i class="el-icon-arrow-down" style="margin-left: 5px;font-size: 14px;"></i>
									</span>
									<el-dropdown-menu slot="dropdown" class="country-dropdown-202211111901">
										<el-dropdown-item v-for="item in countryList" :key="item.value"
											:disabled="submitSearch.country===item.value"
											:command="item.value">
											<i :class="'fi fi-' + item.icon.toLowerCase()"></i>{{ $t('app.countries.'+item.value) }}
										</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>
								<!-- 时间选择 -->
								<el-button class="time-select-line-button"
									v-loading="timeLoading" v-if="windowObj.width_level > 1">
									<span class="color-text-grey-1">
										<span v-if="!submitSearch.timeRange || submitSearch.timeRange.length < 2">
										{{ fomatTimeStr(submitSearch.date[0]) }}
										<span  class="color-text-blue">
											+{{ submitSearch.date.length }}
										</span>
									</span>
										<span v-else>
										{{ $fomatTime(submitSearch.timeRange[0]) }} -
										{{ $fomatTime(submitSearch.timeRange[1]) }}
									</span>
									</span>

									<i style="margin-left: 5px;" class="el-icon-arrow-down"></i>
									<el-select ref="dateSelect"
										class="el-select-class-20220628" multiple collapse-tags
										popper-class="el-select-popper-css-20220930"
										v-model="submitSearch.date" @change="timeSelectChange()">
										<el-option value="null" style="position: relative">
											<div @click.stop style="position: absolute;left: 0;right: 0;top: 0;bottom: 0;padding-left: 20px">
												<el-checkbox v-model="timeSelectMultiple" style="width: 100%">{{$t('aba.time_selector.multiple_choice_mode')}}</el-checkbox>
											</div>
										</el-option>
										<el-option v-for="(item,index) in updateTimeList"
											:disabled="item.locked"
											:key="str(index)" :value="item.date">
											<el-tooltip class="item" effect="dark" :content="$t('aba.time_selector.tips.unlock') + ' ' + fomatTimeStr(item.date)"
												placement="top-start" :disabled="isVip(loginUser) || !item.locked">
												<i style="cursor: pointer"
													@mouseup.stop @click.stop="buyDate(null,item)"
													class="el-icon-unlock icon"></i>
											</el-tooltip>
											{{ fomatTimeStr(item.date) }}
										</el-option>
									</el-select>
								</el-button>
								<!--&lt;!&ndash;日历组件&ndash;&gt;-->
								<time-select-sub :maxTime="getWeekLastDay(new Date(lastUpdateTime))"
									@change="timeSelect" :date="submitSearch.date[0]" ref="CalenderSelect" v-if="windowObj.width_level > 1 && this.$store.state.app.language == 'zh-CN'">
									<el-button  style="color: red;border: 0;background-color: rgba(245, 247, 250);" icon="el-icon-date"></el-button>
								</time-select-sub>
								<!-- 类型选择 -->
								<el-dropdown @command="v => submitSearch.searchType = v" trigger="click" v-if="windowObj.width_level > 1">
									<el-button style="background-color: rgba(245, 247, 250);
									border: 0;border-left: 1px solid #DCDFE6;" class="color-text-grey-1">
										{{ submitSearch.searchType === 'asin' ? $t('aba.type.ASIN') :
										submitSearch.searchType === 'brand' ? $t('aba.type.brand') : $t('aba.type.keyword') }}<i class="el-icon-arrow-down el-icon--right"></i>
									</el-button>
									<el-dropdown-menu slot="dropdown">
										<el-dropdown-item command="asin">{{$t('aba.type.ASIN')}}</el-dropdown-item>
										<el-dropdown-item command="brand">{{$t('aba.type.brand')}}</el-dropdown-item>
										<el-dropdown-item command="keywords">{{$t('aba.type.keyword')}}</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>
							</div>
						</div>
						<div style="flex: 1">
							<el-autocomplete clearable :trigger-on-focus="false" v-model="submitSearch.searchText"
								:placeholder=" $t('aba.search.tips.prefix') + (submitSearch.searchType === 'asin' ? $t('aba.type.ASIN') : submitSearch.searchType === 'brand' ? $t('aba.type.brand') : $t('aba.type.keyword')) + $t('aba.search.tips.suffix')"
								hide-loading @select="search()" style="width: 100%;" select-when-unmatched
								:fetch-suggestions="querySearchAsync" class="el-input-auto-20220711"></el-autocomplete>
						</div>
						<div class="search-div">

							<el-button @click="search(null)"
								style="width: 100px;border-radius: 0;" type="primary">{{$t('aba.search.button')}}
							</el-button>
						</div>
					</div>
					<!-- 示例 -->
					<div class="example-div">
						<span>{{$t('aba.search.example')}}：</span>
						<a v-for="(item,index) in example" :key="str(index)"
							@click="searchTerm(item,submitSearch.searchType,false)">{{ item }}</a>
					</div>
					<!-- 高级筛选参数填写按钮-->
					<div class="rapid-filter-div">
						<el-tooltip v-for="(item,index) in weeklyDefaultConditionType" :key="str(index)"
							:content="$t('aba.market_tag.'+item.value+'.description')" placement="top">
							<a @click="marketClick(null,item.value)">
								<el-tag :type="item.type" style="margin-top: 5px">{{ $t('aba.market_tag.'+item.value+'.name') }}</el-tag>
							</a>
						</el-tooltip>
					</div>
				</div>
			</div>
		</div>
		<!--BODY-->
		<div class="body-data-div">
			<!--筛选条件展示-->
			<div class="filter-criteria-show clear-float">
				<div style="flex: 1;" class="overflow-one-line">
					<span class="item-span" v-if="filterShowObjs && filterShowObjs.length > 0">
						<el-tag v-for="(value,key) in filterShowObjs" :key="key" type="info"
							@close="handleClose(value.delKey)" :closable="isVip(loginUser) && value.delKey.length > 0">
							<span class="default-font-color">{{ value.title }}: </span>
							<span class="emphasis-hint">{{ value.text }}</span>
						</el-tag>
					</span>
<!--					<span v-else class="item-span">-->
<!--						<el-tag type="info">-->
<!--							<span class="default-font-color">{{ '市场:' }} </span>-->
<!--							<span class="emphasis-hint">{{ '热门市场' }}</span>-->
<!--						</el-tag>-->
<!--					</span>-->
				</div>
				<div style="text-align: right;">
					<el-button size="small" type="danger" plain @click="filterOpen=!filterOpen">
						{{$t('aba.filters.title')}}<i :class="'el-icon-arrow-' + (filterOpen ? 'up' : 'down')"></i>
					</el-button>
				</div>
			</div>
			<!--高级筛选条件-->
			<el-collapse-transition>
				<div class="search-filter-body" v-show="filterOpen">
					<el-form size="mini" label-position="left" class="el-form-202210131709">
						<el-descriptions :colon="false" class="descriptions-div-20221114">
							<!--时间范围-->
							<el-descriptions-item :span="3">
								<template slot="label">
									<el-form-item :label="$t('aba.filters.conditions.time_range.name')">
										<div style="display: flex; flex-direction: column;">
											<div class="filter-option" style="display: flex;">
												<el-date-picker v-model="submitSearch.timeRange" style="width: 100%;"
													type="daterange" align="right" unlink-panels range-separator="-"
													:start-placeholder="$t('aba.filters.conditions.time_range.start')" :end-placeholder="$t('aba.filters.conditions.time_range.end')" format="yyyy-MM-dd"
													:picker-options="pickerOptions">
												</el-date-picker>
											</div>
										</div>
									</el-form-item>
								</template>
							</el-descriptions-item>
							<!--节日选择-->
							<el-descriptions-item :span="3">
								<template slot="label">
									<el-form-item :label="$t('aba.filters.conditions.festival.name')">
										<div style="display: flex; flex-direction: column;">
											<div class="filter-option" style="display: flex;">
												<el-dropdown trigger="click" placement="bottom"
													@command="(v) =>{ holidayObj.country = v;loadHoliday(null)}">
													<el-tag size="small" type="info"  effect="plain" class="holiday-country-tag" >
														<i :class="'fi fi-' + getCountryObjByCity(holidayObj.country).icon"> </i>
														<i class="el-icon-arrow-down"
															style="margin-left: 5px;font-size: 14px;"></i>
													</el-tag>
													<el-dropdown-menu slot="dropdown">
														<el-dropdown-item v-for="item in countryList" :key="item.value"
															:disabled="holidayObj.country===item.value" :command="item.value">
															<i :class="'fi fi-' + item.icon.toLowerCase()"></i>{{ item.cn }}
														</el-dropdown-item>
													</el-dropdown-menu>
												</el-dropdown>
												<el-select v-model="holidayObj.month" style="width: 100px;margin-left: 10px"
													@change="loadHoliday(null)">
													<el-option :value="item" :label="language == 'zh-CN' ? item +'月' : getMonthName(item)" v-for="item in 12"
														:key="item"></el-option>
												</el-select>
												<el-select v-model="holidayObj.holiday" style="flex: 1;margin-left: 10px"
													@change="holidaySelectChange" value-key="holidayName" clearable>
													<el-option :value="item" :label="item.holidayNameCh || item.holidayName"
														:disabled="new Date().getMonth() < new Date(item.beginDate).getMonth()"
														v-for="(item,index) in holidays" :key="str(index)">
														{{ item.holidayName }}
														<span v-if="item.holidayName && item.holidayNameCh"> / </span>
														{{ item.holidayNameCh }}
													</el-option>
												</el-select>
											</div>
										</div>
									</el-form-item>
								</template>
							</el-descriptions-item>
							<!--新词挖掘-->
							<el-descriptions-item :span="3">
								<template slot="label">
									<el-form-item :label="$t('aba.filters.conditions.new_keywords.name')">
										<div style="display: flex; flex-direction: column;">
											<div class="filter-option" style="display: flex;">
												<el-select style="width: 100%" v-model="submitSearch.interval" :disabled="batchTimeOrNot">
													<el-option :value="null">{{$t('aba.filters.conditions.new_keywords.options.unselected')}}</el-option>
													<el-option
														:label="language == 'zh-CN' ? '近 ' + item +' 周' : 'Last ' + item +' Week'"
														:value="item"
														v-for="item in 14"
														:key="item"></el-option>
												</el-select>
											</div>
										</div>
									</el-form-item>
								</template>
								<el-row :gutter="10" v-if="windowObj.width_level > 2">
									<el-col :span="2">
										<el-button @click="submitSearch.interval = null" :disabled="batchTimeOrNot"
											:plain="!!submitSearch.interval" size="mini" class="button-item"
											type="danger">
											{{$t('aba.filters.conditions.new_keywords.options.unselected')}}
										</el-button>
									</el-col>
									<el-col :span="2" v-for="i in filterOption['newKeywords']" :key="str(i)">
										<el-button style="padding-left: 0;padding-right: 0" 
										@click="submitSearch.interval = i" :disabled="batchTimeOrNot"
											:plain="submitSearch.interval !== i"
											size="mini" class="button-item" type="danger">
											{{ language == 'zh-CN' ? '近 ' + i +' 周' : i +' Week' }}
										</el-button>
									</el-col>
								</el-row>
							</el-descriptions-item>
							<!--搜索排名-->
							<el-descriptions-item :span="3">
								<template slot="label">
									<el-form-item :label="$t('aba.filters.conditions.search_frequency_rank.name')">
										<div style="display: flex; flex-direction: column;">
											<div class="filter-option" style="display: flex;">
												<el-col :span="11">
													<el-input v-model="submitSearch.minRanking"
														:placeholder="$t('aba.filters.placeholder.min')" clearable
														oninput="value=value.replace(/[^\d]/g,'')">
													</el-input>
												</el-col>
												<el-col :span="2" style="text-align: center;"> -
												</el-col>
												<el-col :span="11">
													<el-input v-model="submitSearch.maxRanking"
														:placeholder="$t('aba.filters.placeholder.max')" clearable
														oninput="value=value.replace(/[^\d]/g,'')">
													</el-input>
												</el-col>
											</div>
										</div>
									</el-form-item>
								</template>
								<div class="">
									<el-row :gutter="10" v-if="windowObj.width_level > 2">
										<el-col :span="2" v-for="i in filterOption['rankingSection']" :key="str(i)">
											<el-button v-if="Array.isArray(i)"
												size="mini" class="button-item" type="danger"
												style="padding-left: 0;padding-right: 0"
												:plain="submitSearch.minRanking !== i[0] || submitSearch.maxRanking !== i[1]"
												@click="submitSearch.minRanking=i[0];submitSearch.maxRanking=i[1]">
												{{ unitConversion2(i[0]) }} - {{ unitConversion2(i[1]) }}
											</el-button>
											<el-button size="mini" class="button-item" type="danger"
												v-else @click="submitSearch.minRanking=i;submitSearch.maxRanking=null"
												:plain="!(!submitSearch.maxRanking && submitSearch.minRanking === i)">
												{{ unitConversion2(i) }}
											</el-button>
										</el-col>
									</el-row>
								</div>
							</el-descriptions-item>
							<!--排名增长量-->
							<el-descriptions-item :span="3">
								<template slot="label">
									<el-form-item :label="$t('aba.filters.conditions.search_frequency_rank_growth.name')">
										<div style="display: flex; flex-direction: column;">
											<div class="filter-option" style="display: flex;">
												<el-col :span="11">
													<el-select :disabled="batchTimeOrNot"
														v-model="submitSearch.increaseTimeType">
														<el-option
															:label="language == 'zh-CN' ? '近 ' + item +' 周' : 'Last ' + item +' Week'"
															:value="item"
															v-for="item in 14"
															:key="item"></el-option>
													</el-select>
												</el-col>
												<el-col :span="2" style="text-align: center;"> -
												</el-col>
												<el-col :span="11">
													<el-input v-model="submitSearch.rankIncrease" :disabled="batchTimeOrNot"
														:placeholder="$t('aba.filters.placeholder.value')" clearable
														oninput="value=value.replace(/[^\d]/g,'')"></el-input>
												</el-col>
											</div>
										</div>
									</el-form-item>
								</template>
								<div class="">
									<el-row :gutter="10" v-if="windowObj.width_level > 2">
										<el-col :span="2" v-for="i in filterOption['rankIncrease']" :key="str(i)">
											<el-button size="mini" class="button-item" type="danger" :disabled="batchTimeOrNot"
												:plain="submitSearch.rankIncrease !== i"
												style="padding-left: 0;padding-right: 0"
												@click="submitSearch.rankIncrease=i">
												{{ unitConversion2(i) }}
											</el-button>
										</el-col>
									</el-row>
								</div>
							</el-descriptions-item>
							<!--排名增长率-->
							<el-descriptions-item :span="3">
								<template slot="label" >
									<el-form-item :label="$t('aba.filters.conditions.search_frequency_rank_growth_rate.name')">
										<div style="display: flex; flex-direction: column;">
											<div class="filter-option" style="display: flex;">
												<el-col :span="11">
													<el-select  :disabled="batchTimeOrNot"
														v-model="submitSearch.rankGrowthRateTimeType">
														<el-option
															:label="language == 'zh-CN' ? '近 ' + item +' 周' : 'Last ' + item +' Week'"
															:value="item"
															v-for="item in 14"
															:key="item"></el-option>
													</el-select>
												</el-col>
												<el-col :span="2" style="text-align: center;"> -
												</el-col>
												<el-col :span="11">
													<el-input v-model="submitSearch.rankGrowthRate" :disabled="batchTimeOrNot"
														:placeholder="$t('aba.filters.placeholder.percent')" clearable
														oninput="value=value.replace(/[^0-9.]/g,'')"
														class="el-input-a-202207010704">
														<template slot="append">%</template>
													</el-input>
												</el-col>
											</div>
										</div>
									</el-form-item>
								</template>
								<div class="">
									<el-row :gutter="10" v-if="windowObj.width_level > 2">
										<el-col :span="2" v-for="i in filterOption['rankingGrowth']" :key="str(i)">
											<el-button size="mini" class="button-item" type="danger"  :disabled="batchTimeOrNot"
												:plain="submitSearch.rankGrowthRate !== i"
												@click="submitSearch.rankGrowthRate=i">
												{{ i }}%
											</el-button>
										</el-col>
									</el-row>
								</div>
							</el-descriptions-item>
							<!--点击总占比-->
							<el-descriptions-item :span="3">
								<template slot="label">
									<el-form-item :label="$t('aba.filters.conditions.clicked_asin_click_rate.name')">
										<div style="display: flex; flex-direction: column;">
											<div class="filter-option" style="display: flex;">
												<el-col :span="11">
													<el-input v-model="submitSearch.minClickShare"
														:placeholder="$t('aba.filters.placeholder.min')" clearable
														oninput="value=value.replace(/[^0-9.]/g,'')"
														class="el-input-a-202207010704">
														<template slot="append">%</template>
													</el-input>
												</el-col>
												<el-col :span="2" style="text-align: center;"> -
												</el-col>
												<el-col :span="11">
													<el-input v-model="submitSearch.maxClickShare"
														:placeholder="$t('aba.filters.placeholder.max')" clearable
														oninput="value=value.replace(/[^0-9.]/g,'')"
														class="el-input-a-202207010704">
														<template slot="append">%</template>
													</el-input>
												</el-col>
											</div>
										</div>
									</el-form-item>
								</template>
								<div class="">
									<el-row :gutter="10" v-if="windowObj.width_level > 2">
										<el-col :span="2" v-for="i in filterOption['clickShareSection']" :key="str(i)">
											<el-button size="mini" class="button-item" type="danger"
												:plain="submitSearch.maxClickShare !== i"
												@click="submitSearch.maxClickShare=i">
												{{ i }}%
											</el-button>
										</el-col>
									</el-row>
								</div>
							</el-descriptions-item>
							<!--转化总占比-->
							<el-descriptions-item :span="3">
								<template slot="label">
									<el-form-item :label="$t('aba.filters.conditions.clicked_asin_conversion_rate.name')">
										<div style="display: flex; flex-direction: column;">
											<div class="filter-option" style="display: flex;">
												<el-col :span="11">
													<el-input
														v-model="submitSearch.minConversionShare"
														:placeholder="$t('aba.filters.placeholder.min')"
														oninput="value=value.replace(/[^0-9.]/g,'')"
														class="el-input-a-202207010704" clearable>
														<template slot="append">%</template>
													</el-input>
												</el-col>
												<el-col :span="2" style="text-align: center;"> -</el-col>
												<el-col :span="11">
													<el-input
														v-model="submitSearch.maxConversionShare"
														:placeholder="$t('aba.filters.placeholder.max')"
														oninput="value=value.replace(/[^0-9.]/g,'')"
														class="el-input-a-202207010704" clearable>
														<template slot="append">%</template>
													</el-input>
												</el-col>
											</div>
										</div>
									</el-form-item>
								</template>
								<div class="">
									<el-row :gutter="10" v-if="windowObj.width_level > 2">
										<el-col :span="2" v-for="i in filterOption['conversionShare']" :key="str(i)">
											<el-button size="mini" class="button-item" type="danger"
												:plain="submitSearch.maxConversionShare !== i"
												@click="submitSearch.maxConversionShare=i">
												{{ i }}%
											</el-button>
										</el-col>
									</el-row>
								</div>
							</el-descriptions-item>
						</el-descriptions>
						<el-row>
							<!--包含关键词-->
							<el-col :xs="24" :sm="12" :md="10" :lg="8" :xl="6">
								<el-form-item :label="$t('aba.filters.conditions.search_term.name')">
									<div class="filter-option">
										<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}"
											:placeholder="$t('aba.filters.conditions.search_term.placeholder')"
											v-model="submitSearch.searchTermIn"></el-input>
									</div>
								</el-form-item>
							</el-col>
							<!--排除关键词-->
							<el-col :xs="24" :sm="12" :md="10" :lg="8" :xl="6">
								<el-form-item :label="$t('aba.filters.conditions.exclude_search_term.name')">
									<div class="filter-option">
										<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}"
											:placeholder="$t('aba.filters.conditions.exclude_search_term.placeholder')"
											v-model="submitSearch.searchTermNotIn"></el-input>
									</div>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<!--包含ASIN-->
							<el-col :xs="24" :sm="12" :md="10" :lg="8" :xl="6">
								<el-form-item :label="$t('aba.filters.conditions.asin.name')">
									<div class="filter-option">
										<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}"
											:placeholder="$t('aba.filters.conditions.asin.placeholder')"
											v-model="submitSearch.asinIn"></el-input>
									</div>
								</el-form-item>
							</el-col>
							<!--排除ASIN-->
							<el-col :xs="24" :sm="12" :md="10" :lg="8" :xl="6">
								<el-form-item :label="$t('aba.filters.conditions.exclude_asin.name')">
									<div class="filter-option">
										<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}"
											:placeholder="$t('aba.filters.conditions.exclude_asin.placeholder')"
											v-model="submitSearch.asinNotIn"></el-input>
									</div>
								</el-form-item>
							</el-col>
						</el-row>						
						<el-row>
							<!--包含品牌-->
							<el-col :xs="24" :sm="12" :md="10" :lg="8" :xl="6">
								<el-form-item :label="$t('aba.filters.conditions.brand.name')">
									<div class="filter-option">
										<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}"
											:placeholder="$t('aba.filters.conditions.brand.placeholder')"
											v-model="submitSearch.brandIn"></el-input>
									</div>
								</el-form-item>
							</el-col>
							<!--排除品牌-->
							<el-col :xs="24" :sm="12" :md="10" :lg="8" :xl="6">
								<el-form-item :label="$t('aba.filters.conditions.exclude_brand.name')">
									<div class="filter-option">
										<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}"
											:placeholder="$t('aba.filters.conditions.exclude_brand.placeholder')"
											v-model="submitSearch.brandNotIn"></el-input>
									</div>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<!--包含类目-->
							<el-col :xs="24" :sm="12" :md="10" :lg="8" :xl="6">
								<el-form-item :label="$t('aba.filters.conditions.category.name')">
									<div class="filter-option">
										<el-select v-model="categoryInArr"
											multiple clearable collapse-tags size="medium" style="width: 100%;margin-bottom: 5px">
											<el-option v-for="item in categories[submitSearch.country.toLowerCase()]"
												:key="item" :label="item" :value="item">
											</el-option>
										</el-select>
										<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}"
											:placeholder="$t('aba.filters.conditions.category.placeholder')"
											v-model="submitSearch.categoryIn"></el-input>
									</div>
								</el-form-item>
							</el-col>
							<!--排除类目-->
							<el-col :xs="24" :sm="12" :md="10" :lg="8" :xl="6">
								<el-form-item :label="$t('aba.filters.conditions.exclude_category.name')">
									<div class="filter-option">
										<el-select v-model="categoryNotInArr"
											multiple clearable collapse-tags size="medium" style="width: 100%;margin-bottom: 5px">
											<el-option v-for="item in categories[submitSearch.country.toLowerCase()]"
												:key="item" :label="item" :value="item">
											</el-option>
										</el-select>

										<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}"
											:placeholder="$t('aba.filters.conditions.exclude_category.placeholder')"
											v-model="submitSearch.categoryNotIn"></el-input>
									</div>
								</el-form-item>
							</el-col>

							<el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="12">
								<div style="text-align: right;line-height: 54px">
									<el-button @click="clearFilter(null)" size="small" plain>
										{{$t('aba.filters.action.clear')}}
									</el-button>
									<el-button @click="search(null)" size="small" type="primary">
										{{$t('aba.filters.action.search')}}
									</el-button>
								</div>
							</el-col>
						</el-row>
					</el-form>
					<!--高级筛选遮罩-->
					<div class="filter-shade" v-if="!isVip(loginUser)">
						<el-empty :image-size="100">
							<span slot="description">
								<el-button v-if="loginUser.isLogin" class="vip-btn-background-css"
									@click="$router.push('/vip/buyVip')">开通会员</el-button>
								<el-button v-else type="primary" @click="$router.push('/sign')">登录</el-button>
							</span>
						</el-empty>
					</div>
				</div>
			</el-collapse-transition>
			<!--关键词数据-->
			<!-- <div style="margin-bottom: 15px;position: relative;"
				v-if="searchData.search  && searchData.search.searchText &&  searchData.search.searchType === 'keywords' && loginUser.isLogin">
				<el-button @click="selectAllTime()"
					style="position: absolute;right: 230px;top: 155px;z-index: 1"
					size="mini">全部时间</el-button>

				<term-reverse-trends :start-time="firstUpdateTime" @clickColumn="clickChartColumn" :term="searchData.search.searchText" :key="searchData.search.searchText" 
					:country="submitSearch.country" :endTime="lastUpdateTime"></term-reverse-trends>
			</div> -->
			<!--asin数据-->
			<!-- <div style="margin-bottom: 15px;position: relative;"
				v-if="searchData.search  && searchData.search.searchText &&  searchData.search.searchType === 'asin' && loginUser.isLogin">
				<el-button @click="selectAllTime()"
					style="position: absolute;right: 230px;top: 155px;z-index: 1"
					size="mini">全部时间</el-button>

				<asin-reverse-trends @clickColumn="clickChartColumn" :asin="searchData.search.searchText"
					:key="searchData.asin" :start-time="firstUpdateTime"
					:country="submitSearch.country" :endTime="lastUpdateTime"></asin-reverse-trends>
			</div> -->
			<div style="margin-bottom: 15px;position: relative;"
				v-if="searchData.search  && searchData.search.searchText &&  searchData.search.searchType === 'asin' && loginUser.isLogin">
				<simple-asin-info :asin="searchData.search.searchText" :key="searchData.asin" :country="submitSearch.country" ></simple-asin-info>
			</div>
			<!--品牌反查关键词数量趋势-->
			<!-- <div  style="margin-bottom: 15px;position: relative;"
				v-if="searchData.search && searchData.search.searchText && searchData.search.searchType === 'brand' && loginUser.isLogin">
				<el-button @click="selectAllTime()"
					style="position: absolute;right: 230px;top: 55px;z-index: 1"
					size="mini">全部时间</el-button>

				<brand-reverse-trends :start-time="firstUpdateTime" @clickColumn="clickChartColumn" :brand="searchData.search.searchText" :key="searchData.search.searchText"
					:country="submitSearch.country" :endTime="lastUpdateTime"></brand-reverse-trends>
			</div> -->

			<div  style="margin-bottom: 15px;position: relative;"
				v-if="searchData.search && searchData.search.searchText && searchData.search.searchType === 'brand' && loginUser.isLogin">

				<brand-reverse-trends2 :date="submitSearch.date" ref="reverseTrends2"
					@clickColumn="(v) => {submitSearch.searchType='brand';searchTerm(v,'brand',false)}"
					:brand="searchData.search.searchText" :key="searchData.search.searchText"
					:country="submitSearch.country" :keywordsSearch="submitSearch"></brand-reverse-trends2>
			</div>
			<!--时间线选择-->
			<div style="margin: 15px 0" v-if="searchTimes && searchTimes.length > 0">
				<el-steps :active="1" align-center class="el-steps-20221121">
					<el-step @click.native="timelineClick(0)" :status="searchTimes[0].status || 'wait'" icon="el-icon-time">
						<template slot="icon">
							<span>{{$t('aba.time_selector.quick_times.current')}}</span>
						</template>
						<template slot="title">
							<el-tooltip class="item" effect="light" :content="fomatTimeStr( searchTimes[0].date)" placement="top">
								<span>{{ fomatTimeStr(searchTimes[0].date) }}</span>
							</el-tooltip>
						</template>
					</el-step>
					<el-step @click.native="timelineClick(1)" :status="searchTimes[1].status || 'wait'" icon="el-icon-time">
						<template slot="icon">
							<span>{{$t('aba.time_selector.quick_times.last_week')}}</span>
						</template>
						<template slot="title">
							<el-tooltip class="item" effect="light" :content="fomatTimeStr( searchTimes[1].date)" placement="top">
								<span>{{ fomatTimeStr( searchTimes[1].date) }}</span>
							</el-tooltip>
						</template>
					</el-step>
					<el-step @click.native="timelineClick(2)" :status="searchTimes[2].status || 'wait'" icon="el-icon-time">
						<template slot="icon">
							<span>{{$t('aba.time_selector.quick_times.last_month')}}</span>
						</template>
						<template slot="title">
							<el-tooltip class="item" effect="light" :content="fomatTimeStr( searchTimes[2].date)" placement="top">
								<span>{{ fomatTimeStr( searchTimes[2].date) }}</span>
							</el-tooltip>
						</template>
					</el-step>
					<el-step  @click.native="timelineClick(3)" :status="searchTimes[3].status || 'wait'" icon="el-icon-time">
						<template slot="icon">
							<span>{{$t('aba.time_selector.quick_times.last_season')}}</span>
						</template>
						<template slot="title">
							<el-tooltip class="item" effect="light" :content="fomatTimeStr( searchTimes[3].date)" placement="top">
								<span>{{ fomatTimeStr( searchTimes[3].date) }}</span>
							</el-tooltip>
						</template>
					</el-step>
					<el-step @click.native="timelineClick(4)" :status="searchTimes[4].status || 'wait'" icon="el-icon-time">
						<template slot="icon">
							<span>{{$t('aba.time_selector.quick_times.last_year')}}</span>
						</template>
						<template slot="title">
							<el-tooltip class="item" effect="light" :content="fomatTimeStr( searchTimes[4].date)" placement="top">
								<span>{{ fomatTimeStr( searchTimes[4].date) }}</span>
							</el-tooltip>
						</template>
					</el-step>
				</el-steps>
			</div>
			<!--词频-->
			<div style="position: relative">
				<div v-show="wordCountObj.loading" class="loading-shadow-div"><i class="el-icon-loading"></i></div>
				<word-count-sub :wordCountObj="wordCountObj" v-if="wordCountObj.data"
					@clickItem="searchTerm"
					@clickMin="val => { addSearchTerm(val,2) }"
					@clickPlus="val => { addSearchTerm(val,1) }"></word-count-sub>
			</div>
			<!--搜索结果反馈-->
			<div class="search-result-div clear-float">
				<!--数量展示-->
				<span v-if="searchData.total">
					{{language == 'zh-CN' ? '搜索结果数量: ' : 'Results: '}}
					<font color="#F56C6C">
						{{ searchData.total }}<i v-if="searchData.total == 10000">+</i>
					</font>
				</span>
				<span v-else>
				{{$t('aba.warring')}}
					<!-- 最后更新时间:<font color="#F56C6C">{{ $fomatTime(dateAdd(lastUpdateTime,'d',6),'yyyy-MM-DD') }}</font> -->
			</span>

				<!--&lt;!&ndash;改变展示模式&ndash;&gt;-->
				<div :style="windowObj.width_level > 1 ? 'float:right;' : ''">
					<span>
						{{$t('aba.mode.search_term.clicked.name')}}: <click-open-type-select @setWeeklyClickType="val => this.$data.weeklyClickType = val"></click-open-type-select>
					</span>
					<span style="margin-right: 10px">
						{{$t('aba.mode.search_term.clicked.action.search.mode.name')}}: <week-open-type-change-sub
						@setOpenMethod="val => this.$data.openMethod = val"></week-open-type-change-sub>
					</span>
					<el-dropdown placement="bottom"
						@command="(v) => v == 1 ? table2csvDownload() : wordCountCsvDownload()"
						:disabled="!loginUser.isLogin">
						<span>
							<el-button v-loading="downloadLoading"
								icon="fa fa-download" size="mini" :disabled="downloadLoading || !loginUser.isLogin"
								type="primary" style="margin-left: 10px" plain>
								{{$t('aba.download.name')}}
							</el-button>
						</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command="1">{{$t('aba.download.action.search_terms')}}</el-dropdown-item>
							<el-dropdown-item command="2">{{$t('aba.download.action.words')}}</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
			</div>
			<!--表格-->
			<div class="table-div">
				<div v-show="loading" class="loading-shadow-div"><i class="el-icon-loading"></i></div>
				<keyword-table-sub :sortBy="submitSearch.sortBy"
					:chineseTranslationObj="searchData.chineseTranslationObj"
					:total="(searchData.maxTotal || searchData.total)" @clickSearchItem="searchTerm"
					ref="tableChildren" :country="searchData.country" :date="searchData.date"
					:searchCriteria="submitSearch"
					:tableData="searchData.results"></keyword-table-sub>
				<!--				分页-->
				<div class="tab-foot-page-div">
					<page-sub :background="true" layout="sizes,prev, pager, next"
						:page-sizes="[50,100]"
						@current-change="pageChange" @size-change="handleSizeChange"
						:total="searchData.maxTotal || searchData.total" :page-size="submitSearch.pageSize"
						:current-page="submitSearch.page"/>
				</div>
			</div>
		</div>

		<!--搜索历史侧栏-->
		<el-drawer title="搜索历史" destroy-on-close :visible.sync="searchHistoryShow" direction="rtl" size="400px">
			<div class="search-history-main">
				<div class="sh-line-data clear-float" v-for="(item,index) in searchHistoryList" :key="str(index)">
					<ul>
						<li style="width:30px;">
							<el-checkbox @change="handleCheckedChange(item.word)"
								:key="searchHistoryChecked.indexOf(item.word)"
								:checked="searchHistoryChecked.indexOf(item.word) != -1"></el-checkbox>
						</li>
						<li style="width: 150px; text-align: left;">
							<div class="overflow-one-line">
								<i style="font-size: 12px;"
									:class="'fi fi-' + getCountryObjByCity(item.country).icon"></i>
								<a @click="searchTerm(item.word);searchHistoryShow=false">
									{{ item.word }}
								</a>
							</div>
						</li>
						<li>
							<font color="#389e0d">
								{{ item.total }}
							</font>
						</li>
						<li style="width: 90px;">
							{{ $timezone(item.searchTime, 'yyyy-MM-DD') }}
						</li>
					</ul>
				</div>
			</div>
			<div class="sh-operate-div">
				<el-checkbox v-model="searchHistoryCheckAll" @change="handleCheckAllChange"></el-checkbox>
				<el-button @click="delSearchHistory(null)" size="small" style="margin: 0 20px;" type="danger"
					icon="el-icon-delete">
					批量删除
				</el-button>
				<span style="float: right;">
					总数量 :
					<font color="#faad14">
						 {{ searchHistoryList.length ? searchHistoryList.length : 0 }}
					</font>
				</span>
			</div>
		</el-drawer>
		<!-- 回到最顶部 -->
		<el-backtop>TOP</el-backtop>
	</div>
</template>

<script>
import KEYWORD_TABLE_SUB from '@/components/template/view/keywordReverseSearch/table/keywordTableDropDown.vue'
import WORD_COUNT from '@/components/template/view/keywordReverseSearch/sub/wordCountSub'
import TIME_SELECT from '@/components/template/view/keywordReverseSearch/sub/timeSelectCalendar'
import TERM_REVERSE_TRENDS from '@/components/template/view/keywordReverseSearch/sub/termTrends'
import ASIN_REVERSE_TRENDS from '@/components/template/view/keywordReverseSearch/sub/asinTrends'
import SIMPLE_ASIN_INFO from '@/components/template/view/keywordReverseSearch/sub/simpleASINInfo'
import BRAND_REVERSE_TRENDS from '@/components/template/view/keywordReverseSearch/sub/brandTrends'
import BRAND_REVERSE_TRENDS2 from '@/components/template/view/keywordReverseSearch/sub/brandAsinNumTrends'
import {
	api_buyDate,
	api_list_keywordReverseSearch,
	api_list_keywordReverseSearch_vip,
	api_list_wordCount
} from '@/components/api/keywordReverseSearch.js'
import {
	filterOption, formatSearchData, formatSearchDataMethod,
	weeklyKeywordsCommonMethod
} from "@/components/template/view/keywordReverseSearch/mixins/weeklyKeywords";
import { isVip } from "@/components/common/member/member";
import PAGE_SUB from '@/components/template/otherSub/pageSub'
import { arrayToObjectByKey, throttle, transformArrayToObj } from "@/components/common/utils/util";
import { getMarketByValue } from "@/components/config/WeeklyKeywordsType";
import {
	appendSheet,
	buildSheet,
	createWorkBook,
	download,
	weeklyTableFields
} from "@/components/common/utils/csv/utils";
import {
	dateAdd,
	fomatTimeStr,
	getMonthEnd,
	getRangeOfMonth,
	getWeekFirstDay,
	getWeekLastDay,
	getMonthName
} from "@/components/common/utils/time";
import { api_listByCountry_holidayDate } from "@/components/api/holidayDate";
import { checkLiving, createKey } from "@/components/common/Living/utils";
import regular, { isAsin } from "@/components/common/utils/regular";
import CATEGORYS from "@/components/config/categories";

export default {
	name: 'weeklyKeyword',
	inject: ['WINDOW', 'F_alertMsg', 'F_windowLoading', 'F_getErrMSg', 'LOGINUSER', 'F_LOGIN', 'F_hintAlert', 'F_costDialog'],
	mixins: [weeklyKeywordsCommonMethod,formatSearchDataMethod],
	data() {
		return {
			temporaryMarket: null,
			categories : CATEGORYS,
			showIndexs: new Set(),
			filterShowObjs: null,
			clickType: localStorage.getItem("weeklyClickType") || 'copy',
			wordCountObj: {
				loading: false,
				data: {},
				keyArr : []
			},
			tableDownload: {
				page: 1,
				pageSize: 200,
				isDownload: true,
			},
			tableDownloadData: {
				list: []
			},
			downloadLoading: false,
			filterOption: filterOption,
			holidayObj: {
				country: 'US',
				month: new Date().getMonth() + 1,
				holiday: null,
			},
			holidays : [],
			searchTimes: [],
			timeSelectMultiple : false,
			time : null
		}
	},
	components: {
		'keyword-table-sub': KEYWORD_TABLE_SUB,
		'page-sub': PAGE_SUB,
		'word-count-sub': WORD_COUNT,
		'time-select-sub': TIME_SELECT,
		'term-reverse-trends' : TERM_REVERSE_TRENDS,
		'asin-reverse-trends' : ASIN_REVERSE_TRENDS,
		'simple-asin-info': SIMPLE_ASIN_INFO,
		'brand-reverse-trends' : BRAND_REVERSE_TRENDS,
		'brand-reverse-trends2' : BRAND_REVERSE_TRENDS2
	},
	computed: {
		pickerOptions(){
			return {
				shortcuts: [
				{
					text: this.$t('app.dateTime.picker.options.last_month'),
					onClick(picker) {
						picker.$emit('pick', [new Date(), new Date()]);
					}
				},
				{
					text: this.$t('app.dateTime.picker.options.last_three_months'),
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setMonth(start.getMonth() - 3);
						picker.$emit('pick', [start, end]);
					}
				},
				{
					text: this.$t('app.dateTime.picker.options.last_six_months'),
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setMonth(start.getMonth() - 6);
						picker.$emit('pick', [start, end]);
					}
				},
				{
					text: this.$t('app.dateTime.picker.options.last_year'),
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setMonth(start.getMonth() - 12);
						picker.$emit('pick', [start, end]);
					}
				},
				{
					text: this.$t('app.dateTime.picker.options.this_year'),
					onClick(picker) {
						const end = new Date();
						const start = new Date(new Date().getFullYear(), 0);
						picker.$emit('pick', [start, end]);
					}
				}]
			}
		},
		example(){
			switch (this.$data.submitSearch.searchType) {
				case "keywords":
					return ["Apple","airpods","ps5","toilet paper"]
				case "asin" :
					switch (this.$data.submitSearch.country) {
						case "US":
							return ["B0BB5HBHGN", "B07PXGQC1Q", "B0947DYSQJ", "B0BTLDPTNP"]
						case "UK":
							return ["B08CN3G4N9", "B0BQWT3ZNQ", "B0931VRJT5", "B0BBS2QDNN"]
						case "DE":
							return ["B08H93ZRK9", "B00IMZJQ4Q", "B0BDJ6QBTL", "B0BDJ61GFY"]
						case "FR":
							return ["B08H93ZRK9", "B00IMZJQ4Q", "B0BDJ6QBTL", "B0BDJ61GFY"]
						case "JP":
							return ["B094JWSV7Q", "B08743NZT9", "B09NT9VLTT", "B09TF8FJP1"]
						case "IT":
							return ["B0B63LNZBW", "B0BDKQHP51", "B07PHPXHQS", "B07B6PNFCM"]
						case "ES":
							return ["B0BWTD1QH1", "B0B9MX76FB", "B095D5XYP4", "B09SWS16W6"]
						case "MX":
							return ["B09DSYGLZ9", "B09DSYGLZ9", "B07C5XD33D", "B09DFCB66S"]
						case "CA":
							return ["B0BCSPHCPD", "B08GL1XSH8", "B0192WG93S", "B08MR2C1T7"]
						case "AU":
							return ["B09Y5TZGF3", "B0B48NDK2C", "B0BCZRM435", "B0BSR111GQ"]
					}

				case "brand" :
					return   ["CRAVEBOX","MEROKEETY","Apple","CQDKWG"]
			}
		},
		batchTimeOrNot(){
			return this.$data.submitSearch.date.length > 1 || (this.$data.submitSearch.timeRange && this.$data.submitSearch.timeRange.length >= 2)
		},
		language() {
			return this.$store.getters.language;
		},
	},
	mounted() {
		window.addEventListener("scroll", this.scrollLoadFun, true);
	},
	created() {
		// 跳转参数捕获
		if (Object.keys(this.$route.query).length > 0) {
			this.$data.submitSearch.country = this.$route.query.country || 'us'
			this.$data.submitSearch.searchText = this.$route.query.searchTerm
			// if(isAsin(this.$route.query.searchTerm)){
			// 	this.$data.submitSearch.searchType = "asin"
			// }
			this.$data.submitSearch.searchType = this.$route.query.searchType || 'keywords'
			if (this.$route.query.date) {
				this.$data.submitSearch.date = [this.$route.query.date]
			}
			this.$router.push({ query: {} });
		}
		// 搜索历史获取
		this.$data.searchHistoryList = localStorage.getItem(this.$data.searchHistoryKey) ? JSON.parse(localStorage.getItem(this.$data.searchHistoryKey)) : []
		// 根据初始货币类型加载时间并且加载表格数据
		let this_ = this
		let b = this.$options.methods.queryCheck(this, () => {
			this_.$options.methods.loadUpdateTime(this_)
		})
		this_.$data.time = new Date().getTime()
		// 加载加载时间参数
		this.$options.methods.loadUpdateTime(this, b)
		// 加载当前假期
		this.$options.methods.loadHoliday(this)
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.scrollLoadFun, true)
	},
	methods: {
		getMonthName : function(month){
			return getMonthName(month)
		},
		str: function(val) {
			return val + ''
		},
		selectAllTime : function() {
			if (!isVip(this.$data.loginUser)){
				this.F_hintAlert(null,2)
				return
			}
			this.$data.submitSearch.timeRange = [new Date(this.$data.firstUpdateTime) ,new Date(this.$data.lastUpdateTime)]
			// 记录搜索时间
			this.$options.methods.setSearchTime(this)
			this.$options.methods.loadData(this)
			this.$options.methods.loadWordCount(this)
			if (this.$refs.reverseTrends2){
				this.$refs.reverseTrends2.loadTrend(null)
			}
		},
		clickChartColumn : function(date){
			let this_ = this
			// 设置搜索参数
			this_.$data.submitSearch.date = [date]
			this.$data.submitSearch.timeRange = []
			if (!this_.$options.methods.queryCheck(this_)) {
				return
			}
			// 记录搜索时间
			this_.$options.methods.setSearchTime(this_)
			this_.$data.submitSearch.page = 1
			// 直接加载数据 不设置参数
			this_.$options.methods.loadData(this_)
			this_.$options.methods.loadWordCount(this_)
			if (this.$refs.reverseTrends2){
				this.$refs.reverseTrends2.loadTrend(null)
			}
		},
		holidaySelectChange : function(item) {
			if (item){
				this.$data.submitSearch.date = [getWeekFirstDay(new Date(item.beginDate))]
			}
		},
		timeSelectChange : function() {
			let this_ = this
			//  参数初始化
			this_.$data.submitSearch.timeRange = []
			this_.$data.holidayObj.holiday = null
			if (this_.$refs.CalenderSelect) {
				this_.$refs.CalenderSelect.clearTime()
			}
			if(!this_.$data.timeSelectMultiple){
				this_.$data.submitSearch.date = [this_.$data.submitSearch.date.pop()]
			}
		},
		loadHoliday : function(this_) {
			this_ = this_ || this
			let country = this_.$data.holidayObj.country
			let monthRange = getRangeOfMonth(new Date(new Date().getFullYear(),this_.$data.holidayObj.month - 1))
			this_.$data.holidayObj.holiday = null
			api_listByCountry_holidayDate(country,monthRange[0],monthRange[1]).then(res => {
				this_.$data.holidays = res.data
			}).catch(err => {
				console.error(err)
			})
		},
		timeSelect: function(time) {
			this.$data.submitSearch.date = [this.$fomatTime(getWeekFirstDay(time))]
		},
		timelineClick: function(index) {
			let this_ = this

			let date = this_.$fomatTime(getWeekFirstDay(this_.$data.searchTimes[index].date))

			this_.$data.submitSearch.page = 1
			let historyKey = createKey(this_.$data.submitSearch.country,date)
			let dateLiving = !checkLiving(historyKey,'weekly_keyword_history_date',this_.$data.loginUser.livingTerm)
			if (dateLiving && this_.$data.updateTimeList.find(i => i.locked && date === i.date)){
				if (!this_.$data.loginUser.isLogin){
					this_.F_hintAlert()
					return;
				}else if (!isVip(this_.$data.loginUser)){
					// 如果不是会员并且没购买过的历史记录 直接执行
					this_.$options.methods.buyDate(this_, { date : date,locked : true } )
					return;
				}
			}
			if (!this_.$options.methods.queryCheck(this_)) {
				return
			}
			// 设置选中状态值
			this_.$data.searchTimes.map(i => delete i.status)
			this_.$data.searchTimes[index].status = 'finish'
			// 设置搜索参数
			this_.$data.submitSearch.date = [date]
			// 直接加载数据 不设置参数
			this_.$options.methods.loadData(this_)
			this_.$options.methods.loadWordCount(this_)
		},
		setSearchTime: function(this_) {
			this_.$data.searchTimes = []
			if (this_.$data.submitSearch.date.length > 1 || this_.$data.submitSearch.timeRange.length >= 2) {
				return
			}
			let time =  new Date((this_.$data.submitSearch.date[0]))

			// 当前时间注入
			this_.$data.searchTimes.push({ date: time, dateStr: this_.$fomatTime(time), status: 'finish' })
			// 上周时间注入
			let lastWeek = getWeekFirstDay(dateAdd(getWeekLastDay(new Date(time)), 'w', -1))
			this_.$data.searchTimes.push({ date: lastWeek, dateStr: this_.$fomatTime(lastWeek) })
			// 上月时间注入
			let lastMonth = getWeekFirstDay(dateAdd(getWeekLastDay(new Date(time)), 'm', -1))
			this_.$data.searchTimes.push({ date: lastMonth, dateStr: this_.$fomatTime(lastMonth) })
			// 上季时间注入
			let lastSeason = getWeekFirstDay(dateAdd(getWeekLastDay(new Date(time)), 'm', -3))
			this_.$data.searchTimes.push({ date: lastSeason, dateStr: this_.$fomatTime(lastSeason) })
			// 去年
			let lastYear = getWeekFirstDay(dateAdd(getWeekLastDay(new Date(time)), 'y', -1))
			this_.$data.searchTimes.push({ date: lastYear, dateStr: this_.$fomatTime(lastYear) })
		},
		addSearchTerm: function(val, type) {
			if (!this.$data.loginUser.isLogin) {
				this.F_hintAlert()
				return
			} else if (!isVip(this.$data.loginUser)) {
				this.F_hintAlert(null, 2)
				return
			}
			if (type === 1) {
				if (this.$data.submitSearch.searchTermIn) {
					this.$data.submitSearch.searchTermIn += (',' + val)
				} else {
					this.$data.submitSearch.searchTermIn = val
				}
			} else {
				if (this.$data.submitSearch.searchTermNotIn) {
					this.$data.submitSearch.searchTermNotIn += (',' + val)
				} else {
					this.$data.submitSearch.searchTermNotIn = val
				}
			}
		},
		scrollLoadFun: function() {
			let this_ = this
			throttle(this_.$options.methods.lazyDom(this_))
			throttle(this_.$options.methods.lazy(this_))
		},
		lazyDom: function(this_) {
			this_ = this_ || this
			if (!this_){
				return
			}
			let dom = document.documentElement  // 展示数据的窗口
			for (let i = 0; i < this_.$data.searchData.results.length; i++) {
				let item =  JSON.parse(JSON.stringify(this_.$data.searchData.results[i]))
				if (item.domLazy) {
					continue;
				}
				let trDom = this_.$refs['tableChildren'].$refs['el_table'].$el.getElementsByClassName('tab-202205300628-tr')[i]
				if (trDom) {
					let rect = trDom.getBoundingClientRect()
					let top = rect.top - 60
					if (top >= 0 && rect.bottom - 150 <= (window.innerHeight || dom.clientHeight)) {
						let lastWeekTime = this_.$fomatTime(getWeekFirstDay(dateAdd(getWeekLastDay(new Date(item.date)), 'w', -1)))
						let weekObj = item.metrics ? item.metrics.find(i => i.date === lastWeekTime) : {}
						item.lastWeek =  { date : lastWeekTime,...weekObj }

						let lastMonthTime = this_.$fomatTime(getWeekFirstDay(dateAdd(getWeekLastDay(new Date(item.date)), 'm', -1)))
						let monthObj = item.metrics ? item.metrics.find(i => i.date === lastMonthTime) : {}
						item.lastMonth = { date : lastMonthTime,...monthObj }

						let threeMonthsAgoTime = this_.$fomatTime(getWeekFirstDay(dateAdd(getWeekLastDay(new Date(item.date)), 'm', -3)))
						let threeMonthsAgohObj =  item.metrics ? item.metrics.find(i => i.date === threeMonthsAgoTime) : {}
						item.threeMonthsAgo = { date : threeMonthsAgoTime, ...threeMonthsAgohObj }
						// dom懒加载 开启
						item.domLazy = true
						this_.$set(this_.$data.searchData.results,i, item)
					}
				}
			}
		},
		searchTerm: function(text, type, target = true) {
			this.$data.submitSearch.searchType = type || 'keywords'
			if (this.$data.openMethod === '_blank' && target) {
				window.open(this.$route.path + '?searchType=' + this.$data.submitSearch.searchType + '&searchTerm=' + text +
					'&country=' + this.$data.searchData.country + '&date=' + this.searchData.date)
			} else {
				if (text) {
					this.$data.submitSearch.searchText = text
				}
				this.$data.submitSearch.page = 1
				if (this.$data.searchData.country) {
					this.$data.submitSearch.country = this.$data.searchData.country
				}
				if (this.$data.submitSearch.searchType === 'asin' && this.$data.submitSearch.searchText) {
					this.$data.searchData.asin = this.$data.submitSearch.searchText
				}else {
					this.$data.searchData.asin = null
				}
				this.$options.methods.loadData(this)
				this.$options.methods.loadWordCount(this)
				if (this.$refs.reverseTrends2){
					this.$refs.reverseTrends2.loadTrend(null)
				}
			}
		},
		handleSizeChange: function(val) {
			if (!this.$data.loginUser.isLogin) {
				this.F_hintAlert()
				return
			}
			this.$data.submitSearch.page = 1
			this.$data.submitSearch.pageSize = val
			this.$options.methods.loadData(this)
			// 回到顶部
			document.documentElement.scrollTop = 0
		},
		pageChange: function(val) {
			if (!this.$data.loginUser.isLogin) {
				this.F_hintAlert()
				return
			}
			this.$data.submitSearch.page = val
			this.$options.methods.loadData(this)
			// 回到顶部
			document.documentElement.scrollTop = 0
		},
		buyDate: function(this_, item) {
			this_ = this_ || this
			if (isVip(this_.$data.loginUser) || !item.locked){
				return
			}
			if (!this_.$data.loginUser.isLogin) {
				this_.F_hintAlert()
			} else {
				let fun = () => {
					api_buyDate(item.date, this_.$data.submitSearch.country).then(res => {
						// 刷新钱包数据
						this_.F_LOGIN()
						this_.$options.methods.loadUpdateTime(this_, false)
						this_.F_alertMsg('解锁成功', 2)
					}).catch(err => {
						console.error(err)
						this_.F_alertMsg(this_.F_getErrMSg(err, '购买时间失败：'), 4)
					})
				}
				if (item.locked) {
					this_.F_costDialog(null, 'weekly_keyword_history_date', () => {
						fun()
					})
				} else {
					fun()
				}
			}
		},
		search: function(this_) {
			this_ = this_ || this
			if (!this_.$options.methods.queryCheck(this_)) {
				return
			}

			this_.$data.submitSearch.page = 1
			// 记录搜索时间
			this_.$options.methods.setSearchTime(this_)
			if (this_.$data.submitSearch.searchType == 'asin' && this_.$data.submitSearch.searchText){
				this_.$data.searchData.asin = this_.$data.submitSearch.searchText
			}else {
				this_.$data.searchData.asin = null
			}
			this_.$options.methods.loadWordCount(this_)
			this_.$options.methods.loadData(this_)
			if (this.$refs.reverseTrends2) {
				this.$refs.reverseTrends2.loadTrend(null)
			}
		},
		loadData: function(this_) {
			this_ = this_ || this
			if (this_.$data.loading) return
			let search = JSON.parse(JSON.stringify(this_.$data.submitSearch))
			// 整理请求参数
			let obj = this_.$options.methods.formatSearchData(this_)
			//控制加载方法
			let loadFun = api_list_keywordReverseSearch
			if (isVip(this_.$data.loginUser))
				loadFun = api_list_keywordReverseSearch_vip
			// 开启遮罩
			this_.$data.loading = true
			this_.$data.searchData.search = {...search}
			loadFun(obj).then(res => {
				let data = res.data
				data.results.map(i => {
					i.clicked_brand = transformArrayToObj(i.clicked_brand || [],'rank')
					i.clicked_category = transformArrayToObj(i.clicked_category || [],'rank')
					return i
				})
				// 如果调用了市场类型刷新钱包数据
				if (data.search.tag) {
					// 刷新钱包数据
					this_.F_LOGIN()
				}
				delete data.search
				this_.$data.searchData = {...this_.$data.searchData , ...data,}
				// 关闭遮罩
				this_.$data.loading = false
				// 保存历史记录
				let key = this_.$data.searchHistoryKey
				let l = localStorage.getItem(key)
				let arr = l ? JSON.parse(l) : [];
				let termIndex = arr.findIndex(i => i.word === data.search_term)
				if (termIndex !== -1) {
					arr.splice(termIndex, 1)
				}
				if (data.search_term) {
					arr.unshift({
						word: data.search_term,
						country: data.country,
						total: data.total,
						searchTime: new Date()
					})
					this_.$data.searchHistoryList = arr
					localStorage.setItem(key, JSON.stringify(arr))
				}
				// 保存搜索条件快照
				this_.$data.filterShowObjs = this_.$options.methods.getFilterShowObj(this_,search)
				// 清除旧的的下载数据
				this_.$data.tableDownloadData.list = []
				//异步加载其他信息
				this_.$nextTick(() => {
					//瞬移到顶部
					// window.scrollTo(0, 0)
					this_.$options.methods.lazyDom(this_)
					// this_.$options.methods.loadBatchAsinInfo(this_,data.results)
					this_.$options.methods.lazy(this_)
				})
			}).catch(err => {
				console.error(err)
				// 关闭遮罩
				this_.$data.loading = false
				this_.F_alertMsg('系统繁忙,请稍后再试', 4)
			})
		},
		loadWordCount: function(this_) {
			this_ = this_ || this
			if (this_.$data.wordCountObj.loading) {
				return
			}
			// 遮罩启动
			this_.$data.wordCountObj.loading = true
			// 整理请求参数
			let obj = this_.$options.methods.formatSearchData(this_)
			api_list_wordCount(obj).then(res => {
				let keyArr = Object.keys(res.data).sort(function(a, b) {
					return res.data[b] - res.data[a];   //升序
				});
				this_.$data.wordCountObj.data = res.data
				this_.$data.wordCountObj.keyArr = keyArr
				// 遮罩关闭
				this_.$data.wordCountObj.loading = false
			}).catch(err => {
				// 遮罩关闭
				this_.$data.wordCountObj.loading = false
				console.error(err)
			})
		},
		lazy: function(this_) {
			this_ = this_ || this
			let dom = window;  // 展示数据的窗口
			let list = this_.$data.searchData.results
			if (!this_.$refs['tableChildren'] || !this_.$refs['tableChildren'].$refs['el_table']) {
				return
			}
			let trDomList = this_.$refs['tableChildren'].$refs['el_table'].$el.getElementsByClassName('tab-202205300628-tr')
			if (trDomList && trDomList.length > 0) {
				for (let index = 0; index < trDomList.length; index++) {
					let trDom = trDomList[index]
					if (((index === 0 || index % 15 === 0) || this_.$data.showIndexs.has(index)) && !list[index].lazy) {
						let rect = trDom.getBoundingClientRect()
						this_.$data.showIndexs.add(index)
						let top = rect.top - 60
						let bottom = rect.bottom - 150
						let height = dom.clientHeight || window.innerHeight
						if (top >= 0 && bottom <= height) {
							let endIndex = index + 15
							let keywords = list.slice(index, endIndex)
							if (this_.$data.submitSearch.country !== 'US') {
								this_.$options.methods.loadBatchAsinInfo(this_, keywords)
							}
							for (let i = index; i < endIndex; i++) {
								if (this_.$data.searchData.results[i]) {
									this_.$data.searchData.results[i].lazy = true
								}
							}
						}
					}
				}
			}
		},
		getFilterShowObj: function(this_,obj) {		
			this_ = this_ || this	
			let arr = []
			// let filterKey = ['rankGrowthRate', 'searchTermIn', 'searchTermNotIn']
			// 搜索类型
			if (obj.searchType !== 'keywords'){
				arr.push({ title: this_.$t('aba.type.name'), text: obj.searchType === 'asin' ? this_.$t('aba.type.ASIN') : this_.$t('aba.type.brand') , delKey: [] })
			}
			// 时间范围
			if (obj.timeRange.length === 2) {
				arr.push({ title: this_.$t('aba.filters.conditions.time_range.name'), text: this_.$fomatTime(obj.timeRange[0]) + ' ~ ' + this_.$fomatTime(obj.timeRange[1]), delKey: ['timeRange'] })
			}else {
				// 时间选择
				arr.push({ title: this_.$t('aba.filters.conditions.time_range.name'), text: obj.date.map(i => fomatTimeStr(i)).join(","), delKey: ['date'] })
			}
			// 市场
			if(obj.tag){
				arr.push({ title: this_.$t('aba.market'), text: this_.$t('aba.market_tag.' + getMarketByValue(obj.tag).value + '.name'), delKey: ['tag'] })
			}
			// 新词挖掘
			if (obj.interval) {
				arr.push({ title: this_.$t('aba.filters.conditions.new_keywords.name'), text: this_.language == 'zh-CN' ?  '近' + obj.interval + '周' : 'Last ' + obj.interval + ' Week' , delKey: ['interval'] })
			}
			//  排名条件
			if (obj.minRanking || obj.maxRanking) {
				if (obj.minRanking && !obj.maxRanking) {
					arr.push({ title: this_.$t('aba.filters.conditions.search_frequency_rank.name'), text: ' > ' + obj.minRanking, delKey: ['minRanking'] })
				} else if (obj.maxRanking && !obj.minRanking) {
					arr.push({ title: this_.$t('aba.filters.conditions.search_frequency_rank.name'), text: ' < ' + obj.maxRanking, delKey: ['maxRanking'] })
				} else {
					arr.push({
						title: this_.$t('aba.filters.conditions.search_frequency_rank.name'),
						text: obj.minRanking + ' ~ ' + obj.maxRanking,
						delKey: ['minRanking', 'maxRanking']
					})
				}
			}
			// 排名增长量
			if (obj.rankIncrease) {
				arr.push({
					title: this_.$t('aba.filters.conditions.search_frequency_rank_growth.name'),
					text: (this_.language == 'zh-CN' ? '近' + obj.increaseTimeType + '周' : 'Last ' + obj.increaseTimeType + ' Week') + ' > ' + obj.rankIncrease,
					delKey: ['rankIncrease']
				})
			}
			// 排名增长率
			if (obj.rankGrowthRate) {
				arr.push({
					title: this_.$t('aba.filters.conditions.search_frequency_rank_growth_rate.name'),
					text: (this_.language == 'zh-CN' ? '近' + obj.increaseTimeType + '周' : 'Last ' + obj.increaseTimeType + ' Week') + ' > ' + obj.rankGrowthRate + '%',
					delKey: ['rankGrowthRate']
				})
			}
			// 点击率条件
			if (obj.minClickShare || obj.maxClickShare) {
				if (obj.minClickShare && !obj.maxClickShare) {
					arr.push({ title: this_.$t('aba.filters.conditions.clicked_asin_click_rate.name'), text: ' > ' + obj.minClickShare + '%', delKey: ['minClickShare'] })
				} else if (obj.maxClickShare && !obj.minClickShare) {
					arr.push({ title: this_.$t('aba.filters.conditions.clicked_asin_click_rate.name'), text: ' < ' + obj.maxClickShare + '%', delKey: ['maxClickShare'] })
				} else {
					arr.push({
						title: this_.$t('aba.filters.conditions.clicked_asin_click_rate.name'),
						text: obj.minClickShare + '% ~ ' + obj.maxClickShare + '%',
						delKey: ['minClickShare', 'maxClickShare']
					})
				}
			}
			// 转化率条件
			if (obj.minConversionShare || obj.maxConversionShare) {
				if (obj.minConversionShare && !obj.maxConversionShare) {
					arr.push({
						title: this_.$t('aba.filters.conditions.clicked_asin_conversion_rate.name'),
						text: ' > ' + obj.minConversionShare + '%',
						delKey: ['minConversionShare']
					})
				} else if (obj.maxConversionShare && !obj.minConversionShare) {
					arr.push({
						title: this_.$t('aba.filters.conditions.clicked_asin_conversion_rate.name'),
						text: ' < ' + obj.maxConversionShare + '%',
						delKey: ['maxConversionShare']
					})
				} else {
					arr.push({
						title: this_.$t('aba.filters.conditions.clicked_asin_conversion_rate.name'),
						text: obj.minConversionShare + '% ~ ' + obj.maxConversionShare + '%',
						delKey: ['minConversionShare', 'maxConversionShare']
					})
				}
			}
			// 包含关键词
			if (obj.searchTermIn) {
				arr.push({ title: this_.$t('aba.filters.conditions.search_term.name'), text:  obj.searchTermIn, delKey: ['searchTermIn'] })
			}
			// 不包含关键词
			if (obj.searchTermNotIn) {
				arr.push({ title: this_.$t('aba.filters.conditions.exclude_search_term.name'), text: obj.searchTermNotIn, delKey: ['searchTermNotIn'] })
			}

			// 包含商品
			if (obj.asinIn) {
				arr.push({ title: this_.$t('aba.filters.conditions.asin.name'), text: obj.asinIn, delKey: ['asinIn'] })
			}
			// 不包含商品
			if (obj.asinNotIn) {
				arr.push({ title: this_.$t('aba.filters.conditions.exclude_asin.name'), text: obj.asinNotIn, delKey: ['asinNotIn'] })
			}

			// 包含品牌
			if (obj.brandIn) {
				arr.push({ title: this_.$t('aba.filters.conditions.brand.name'), text: obj.brandIn, delKey: ['brandIn'] })
			}
			// 不包含品牌
			if (obj.brandNotIn) {
				arr.push({ title: this_.$t('aba.filters.conditions.exclude_brand.name'), text: obj.brandNotIn, delKey: ['brandNotIn'] })
			}

			// 包含类目
			if (obj.categoryIn) {
				arr.push({ title: this_.$t('aba.filters.conditions.category.name'), text: obj.categoryIn, delKey: ['categoryIn'] })
			}
			// 不包含类目
			if (obj.categoryNotIn) {
				arr.push({ title: this_.$t('aba.filters.conditions.exclude_category.name'), text: obj.categoryNotIn, delKey: ['categoryNotIn'] })
			}

			return arr
		},
		handleClose(tag) {
			tag.forEach(key => {
				if (key === 'tag') {
					this.$router.push('/')
				}else if (key === 'date') {
					this.$data.submitSearch.date = [this.$data.lastUpdateTime]
				}else if (key === 'timeRange') {
					this.$data.submitSearch.timeRange = []
				}else {
					this.$data.submitSearch[key] = null
				}
			})
			this.$options.methods.search(this)
		},
		table2csvDownload: function(this_) {
			this_ = this_ || this
			let tableData = this_.$data.tableDownloadData
			// 开启遮罩
			this_.$data.downloadLoading = true
			let loadFun = api_list_keywordReverseSearch
			if (isVip(this_.$data.loginUser)) loadFun = api_list_keywordReverseSearch_vip
			if (this_.$data.tableDownload.page === 1) {
				let pageSize = this_.$data.tableDownload.pageSize
				// 设置默认搜索条件 整理请求参数

				let obj = this_.$options.methods.formatSearchData(this_,this_.$data.searchData.search)
				this_.$data.tableDownload = { ...obj,
					...this_.$data.tableDownload
				}
				this_.$data.tableDownload.pageSize = pageSize
				loadFun(this_.$data.tableDownload).then(res => {
					// 保存结果
					tableData.list.push(...res.data.results)
					tableData.search_term = res.data.search_term
					tableData.search = res.data.search
					tableData.total = res.data.total
					this_.$data.tableDownload.page++
					tableData.size = Math.ceil((tableData.total >= 1000 ? 1000 : tableData.total) / this_.$data.tableDownload.pageSize) - 1

					this_.$options.methods.table2csvDownload(this_)
				}).catch(err => {
					// 关闭遮罩
					this_.$data.downloadLoading = false
					console.error(err)
				})
			}else {
				let funArr = []
				for (let i = 0; i < tableData.size ; i++) {
					funArr.push(new Promise((resolve,reject) => {
						loadFun(this_.$data.tableDownload).then(res => {
							// 保存结果
							tableData.list.push(...res.data.results)
							resolve(this_.$data.tableDownload.page)
						}).catch(err => {
							// 关闭遮罩
							this_.$data.downloadLoading = false
							console.error(err)
						})
						this_.$data.tableDownload.page++
					}))
				}
				Promise.all(funArr).then(res => {
					const workbook = createWorkBook();
					// 格式化点击商品数据
					let formatData = tableData.list.map(i => {
						let str1 ='',str2 = ''
						for (let j = 0; j < 3 ; j++) {

							str1 += i.clicked_brand[j] ? i.clicked_brand[j].brand : ''
							str2 += i.clicked_category[j] ? i.clicked_category[j].category : ''
							if (j !== 2){
								str1 += ','
								str2 += ','
							}
						}
						i.clicked_brand = str1
						i.clicked_category = str2
						if (i.clicked_asin) {
							try {
								i.top1 = i.clicked_asin[0].asin
								i.top2 = i.clicked_asin[1].asin
								i.top3 = i.clicked_asin[2].asin
							} catch (e) {
								console.error(e)
							}
							delete i.clicked_asin
						}
						return i
					})
					let ws = buildSheet(formatData, weeklyTableFields)
					// updateHeader(ws,reverseFields)
					appendSheet(workbook, ws)
					download(workbook, "品牌分析结果_" + (tableData.search_term || getMarketByValue(tableData.search.tag).cn))
					// 关闭遮罩
					this_.$data.downloadLoading = false
					// 搜索条件初始化
					this_.$data.tableDownload = this_.$options.data().tableDownload
					// 搜索结果初始化
					this_.$data.tableDownloadData = this_.$options.data().tableDownloadData
				}).catch(err => {
					console.error(err)
				})
			}
		},
		wordCountCsvDownload: function(this_) {
			this_ = this_ || this
			let data = this_.$data.wordCountObj
			const workbook = createWorkBook();
			let list = data.keyArr.map(i => {
				return { word: i, value: data.data[i] }
			})
			let ws = null
			ws = buildSheet(list, { word: '单词', value: '词频' })
			appendSheet(workbook, ws)
			download(workbook, '品牌分析词频_' + this_.$data.searchData.search_term ||
				getMarketByValue(this_.$data.searchData.search.tag).cn)
		}
	},
	watch: {
		searchData : {
			handler(newVal,oldVal) {
			},
			deep : true
		},
		categoryInArr(val){
			this.$data.submitSearch.categoryIn = val.join("\n")
		},
		categoryNotInArr(val){
			this.$data.submitSearch.categoryNotIn = val.join("\n")
		},
		'submitSearch.categoryIn' : {
			handler(val) {
				this.$data.categoryInArr = val ? val.split("\n").filter(i => i) : []
			}
		},
		'submitSearch.categoryNotIn' : {
			handler(val) {
				this.$data.categoryNotInArr = val ? val.split("\n").filter(i => i) : []
			}
		},
		'submitSearch.date' : {
			handler(newVal,oldVal) {
				newVal = newVal.filter(i => i)
				if (newVal.length <= 0){
					this.$data.submitSearch.date = oldVal
				}
			}
		},
		'submitSearch.timeRange' : {
			handler(newVal) {

				if (newVal && newVal.length === 2 && newVal[0].getTime() === newVal[1].getTime()){
					this.$data.submitSearch.timeRange[1] = getMonthEnd(newVal[1])
				}
			}
		}
	},
}
</script>

<style scoped>
.main-div-20220-14 {
	margin: auto;
}
/* 加载遮罩 */
.loading-shadow-div{
	position: absolute;
	left: 1px;
	right: 1px;
	top: 1px;
	bottom: 1px;
	background-color: rgb(255 255 255 / 90%);
	z-index: 1;
	display: flex;
	font-weight: bolder;
	font-size: 18px;
	align-items: center;  /* 定义body的元素垂直居中（/主轴居中-主轴默认是x轴）*/
	justify-content: center; /* 定义body的元素水平居中//侧轴居中-主轴默认是y轴）*/
}

.search-btn {
	border-top-left-radius: 0px;
	border-bottom-left-radius: 0px;
	background-color: #409eff !important;
	color: #fff !important;
}

.search-btn:hover {
	background-color: #2b7cd9 !important;
}

/*搜索栏*/
.search-bar-div {
	display: flex;
	margin: 5px 27px;
	font-size: 14px;
}
.search-bar-div .group {
	display: flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	height: 100%;
	font-size: 14px;color: #909399;cursor: pointer;
}
.search-bar-div .country-select-div {
	border: 1px solid #DCDFE6;
	background-color: rgba(245, 247, 250);
	box-sizing: border-box;
	border-right: 0;
	padding-left: 20px;
	z-index: 1;
	border-top-left-radius: 4px;
	border-bottom-left-radius: 4px;
}
.search-bar-div .search-div {
	border-top-right-radius: 4px;
	border-bottom-right-radius: 4px;
	box-sizing: border-box;
	border-left: 0;
	overflow: hidden;
}

.time-select-line-button {
	position: relative;
	margin-left: 9px;
	border: 0;
	border-radius: 0;
	border-left: 1px solid #DCDFE6;
	border-right: 1px solid #DCDFE6;
	background-color: rgba(245, 247, 250);
}

.example-div {
	font-size: 14px;
	color: #bfbfbf !important;
	text-align: center;
}

.example-div a {
	display: inline-block;
	color: #bfbfbf;
	border-bottom: 1px dashed #bfbfbf;
	margin-right: 20px;
}

.example-div a:hover {
	color: #faad14;
	border-bottom: 1px dashed #faad14;
}

.num-text {
	padding: 0 3px;
	color: #F56C6C;
}

.top-div {
	color: #606266;
	/* text-align: center; */
}

.top-text-div {
	padding: 80px 15% 80px 15%;
}

.body-data-div {
	margin: 0px 3%;
}

/* 筛选栏 */
.search-filter-body {
	padding-top: 10px;
	/* border-top: 1px solid #DCDFE6; */
	/*margin-bottom: 5px;*/
	position: relative;
}
.search-filter-body .button-item {
	width: 100%;
}
.search-filter-body .is-disabled{
	color: #909399;
	background: #f4f4f5;
	border-color: #d3d4d6;
}
.search-filter-body .is-disabled:hover{
	color: #909399;
	background: #f4f4f5;
	border-color: #d3d4d6;
}
.search-filter-body .filter-shade {
	position: absolute;
	background-color: rgb(140, 140, 140, 0.5);
	top: 0;
	bottom: 0;
	left: -10px;
	right: -10px;
	border: 1px solid #DCDFE6;
	border-radius: 8px;
	text-align: center;
}
.search-filter-body .filter-option {
	
}
.rapid-filter-div {
	margin-top: 15px;
	text-align: center;
}
.rapid-filter-div a {
	margin: 0 5px;
}
.holiday-country-tag{
	cursor: pointer;
	height: 28px;
	line-height: 28px;
}

/* 搜索结果数量 */
.search-result-div {
	color: #909399;
	font-size: 13px;
	padding: 12px 0;
	line-height: 25px;
}

/*横向时间轴*/
.time-horizontal {
	list-style-type: none;
	border-top: 3px solid #E4E7ED;
	padding: 0;
	margin: 12px 0;
	font-size: 14px;
}
.time-horizontal li {
	float: left;
	position: relative;
	text-align: center;
	width: 28%;
	padding-top: 15px;
	cursor: pointer;
	color: #909399;
}
.time-horizontal li b{
	content: '';
	position: absolute;
	top: -7px;
	left: 50%;
	width: 8px;
	height: 8px;
	border: 2px solid transparent;
	border-radius: 8px;
	background-color:#E4E7ED;
}
.time-horizontal li span{
	font-size: 12px;
}
.time-check{
	color: #F56C6C !important;
}
.time-check b{
	background-color: #F56C6C !important;
}

/*筛选条件展示*/
.filter-criteria-show {
	/*margin-bottom: 7px;*/
	display: flex;
}

.filter-criteria-show .item-span > span {
	margin-right: 5px;
	margin-bottom: 5px;
	cursor: pointer;
	display: inline-block;
}

.filter-criteria-show .item-span > span:hover {
	background-color: #FFFFFF;
	border-color: #F56C6C;
}

/* 表格父级盒子 */
.table-div {
	position: relative;
}

.table-div .tab-foot-page-div {
	text-align: right;
	margin: 30px 0;
}

.search-history-main {
	border-bottom: 1px solid #E4E7ED;
}

.sh-line-data {
	border-top: 1px solid #E4E7ED;
	padding: 15px 10px;
}

.sh-line-data ul {
	margin: 0px;
	padding: 0px;
}

.sh-line-data ul li {
	float: left;
	list-style: none;
	width: 60px;
	height: 20px;
	line-height: 20px;
	text-align: center;
	margin: 0px 5px;
}

.sh-operate-div {
	padding: 20px;
}

.el-select-class-20220628 {
	position: absolute;
	opacity: 0;
	left: 0;
	right: 0;
	top: 0;
}

.el-select-class-20220628-0223 {
	position: absolute;
	opacity: 0;
	left: 0;
	right: 0;

}
</style>

<style>
.el-step__icon.is-icon {
	width: 100px;
}

.el-input-auto-20220711 input {
	border-radius: 0 !important;
}


/* .el-dropdown-202206240611{
	height: 300px;
	overflow-y: auto;
}

.el-dropdown-202206240611 li{
	margin-left: 8px;
} */
.el-options-class-20220629-0223 .el-select-dropdown__wrap {
	max-height: none;
}

.el-select-popper-css-20220930 .icon {
	line-height: 34px;
	min-width: 20px;
}

.el-select-popper-css-20220930 .icon:hover {
	color: #fadb14;
}

.el-input-a-202207010704 .el-input-group__append {
	margin: 0;
	padding: 0 7px;
}

.descriptions-div-20221114 .el-descriptions-item__content {
	display: block;
}

.descriptions-div-20221114 .el-descriptions-item__cell {
	padding-bottom: 0 !important;
}

.el-form-202210131709 {
	display: inline-block;
}

.el-form-202210131709 label {
  font-weight: bold;
}

.el-form-202210131709 .el-form-item {
	width: 400px;
	margin-bottom: 5px !important;
}

.el-steps-20221121 .el-step{
	cursor: pointer;
}
.el-steps-20221121 .el-step__title{
	font-size: 12px;
	line-height: 24px;
}
.el-steps-20221121 .is-finish{
	color: #F56C6C;
}
.el-steps-20221121 .el-step:not(.el-step:last-child,.el-step:first-of-type){
	flex-basis: 33% !important;
}
.el-steps-20221121 .el-step:not(.el-step:last-child,.el-step:first-of-type) .el-step__line{
	left: -60px;
	right: -50px;
}
.el-steps-20221121 .el-step:first-of-type{
	flex-basis: 20% !important;
}
.el-steps-20221121 .el-step:first-of-type .el-step__line{
	background-color: #FFFFFF;
}
.el-steps-20221121 .el-step:last-child .el-step__line{
	background-color: #FFFFFF;
}
.el-steps-20221121 .el-step:last-child{
	flex-basis: 20% !important;
}
</style>

